import Arcade4FunHero from "../assets/projects/arcade4fun/hero.jpeg";
import SweetHome3DHero from '../assets/projects/sweethome3d/home.png';
import SweetHome3DThumbnail from '../assets/projects/sweethome3d/interior.png';
import SweetHome3DIcon from '../assets/projects/sweethome3d/icon.png';
import SweetHome3DBanner from '../assets/projects/sweethome3d/banner.jpg';
import SweetHome3DMac1 from '../assets/projects/sweethome3d/screenshot-mac-1.webp';
import SweetHome3DMac2 from '../assets/projects/sweethome3d/screenshot-mac-2.webp';
import SweetHome3DMobile4 from '../assets/projects/sweethome3d/screenshot-mobile-4.webp';
import SweetHome3DMobile3 from '../assets/projects/sweethome3d/screenshot-mobile-3.webp';
import SweetHome3DMobile2 from '../assets/projects/sweethome3d/screenshot-mobile-2.webp';
import Arcade4FunThumbnail from '../assets/projects/arcade4fun/thumb.jpeg';
import Arcade4FunIcon from '../assets/projects/arcade4fun/icon.jpeg';
import Arcade4FunBanner from '../assets/projects/arcade4fun/banner.jpeg';
import Arcade4FunScreenshot1 from '../assets/projects/arcade4fun/screenshot1.jpeg';
import Arcade4FunScreenshot2 from '../assets/projects/arcade4fun/screenshot2.jpeg';

import PocketHamsterManiaHero from "../assets/projects/pockethamstermania/hero.jpeg";
import PocketHamsterManiaThumbnail from '../assets/projects/pockethamstermania/thumb.jpeg';
import PocketHamsterManiaIcon from '../assets/projects/pockethamstermania/icon.jpeg';
import PocketHamsterManiaBanner from '../assets/projects/pockethamstermania/banner.jpeg';
import PocketHamsterManiaScreenshot1 from '../assets/projects/pockethamstermania/screenshot1.jpeg';
import PocketHamsterManiaScreenshot2 from '../assets/projects/pockethamstermania/screenshot2.jpeg';
import PocketHamsterManiaScreenshot3 from '../assets/projects/pockethamstermania/screenshot3.jpeg';
import PocketHamsterManiaScreenshot4 from '../assets/projects/pockethamstermania/screenshot4.jpeg';
import PocketHamsterManiaScreenshot5 from '../assets/projects/pockethamstermania/screenshot5.jpeg';
import PocketHamsterManiaScreenshot6 from '../assets/projects/pockethamstermania/screenshot6.jpeg';
import PocketHamsterManiaScreenshot7 from '../assets/projects/pockethamstermania/screenshot7.jpeg';
import PocketHamsterManiaScreenshot8 from '../assets/projects/pockethamstermania/screenshot8.jpeg';

import YatamaHero from '../assets/projects/yatama/hero.jpeg';
import YatamaThumbnail from '../assets/projects/yatama/thumb.jpeg';
import YatamaIcon from '../assets/projects/yatama/icon.jpeg';
import YatamaBanner from '../assets/projects/yatama/banner.jpeg';
import YatamaScreenshot1 from '../assets/projects/yatama/screenshot1.webp';
import YatamaScreenshot2 from '../assets/projects/yatama/screenshot2.webp';
import YatamaScreenshot3 from '../assets/projects/yatama/screenshot3.webp';
import YatamaScreenshot4 from '../assets/projects/yatama/screenshot4.webp';
import YatamaScreenshot5 from '../assets/projects/yatama/screenshot5.webp';
import YatamaScreenshot6 from '../assets/projects/yatama/screenshot6.webp';
import YatamaScreenshot7 from '../assets/projects/yatama/screenshot7.webp';

import FilbingBoxHero from '../assets/projects/filbingbox/hero.jpeg';
import FilbingBoxThumbnail from '../assets/projects/filbingbox/thumb.jpeg';
import FilbingBoxIcon from '../assets/projects/filbingbox/icon.jpeg';
import FilbingBoxBanner from '../assets/projects/filbingbox/banner.jpeg';
import FilbingBoxScreenshot1 from '../assets/projects/filbingbox/screenshot1.jpeg';
import FilbingBoxScreenshot2 from '../assets/projects/filbingbox/screenshot2.jpeg';
import FilbingBoxScreenshot3 from '../assets/projects/filbingbox/screenshot3.jpeg';
import FilbingBoxScreenshot4 from '../assets/projects/filbingbox/screenshot4.webp';
import FilbingBoxScreenshot5 from '../assets/projects/filbingbox/screenshot5.webp';

import TrackAndBurnHero from '../assets/projects/trackandburn/hero.jpeg';
import TrackAndBurnThumbnail from '../assets/projects/trackandburn/thumb.jpeg';
import TrackAndBurnIcon from '../assets/projects/trackandburn/icon.jpeg';
import TrackAndBurnBanner from '../assets/projects/trackandburn/banner.jpeg';
import TrackAndBurnScreenshot1 from '../assets/projects/trackandburn/screenshot1.jpeg';
import TrackAndBurnScreenshot2 from '../assets/projects/trackandburn/screenshot2.jpeg';
import TrackAndBurnScreenshot3 from '../assets/projects/trackandburn/screenshot3.jpeg';
import TrackAndBurnScreenshot4 from '../assets/projects/trackandburn/screenshot4.jpeg';
import TrackAndBurnScreenshot5 from '../assets/projects/trackandburn/screenshot5.jpeg';
import TrackAndBurnScreenshot6 from '../assets/projects/trackandburn/screenshot6.jpeg';

import SSBEHero from '../assets/projects/ssbe/hero.jpeg';
import SSBEThumbnail from '../assets/projects/ssbe/thumb.jpeg';
import SSBEIcon from '../assets/projects/ssbe/icon.jpeg';
import SSBEBanner from '../assets/projects/ssbe/banner.jpeg';
import SSBEScreenshot1 from '../assets/projects/ssbe/screenshot1.jpeg';
import SSBEScreenshot2 from '../assets/projects/ssbe/screenshot2.jpeg';

import JetItNowHero from '../assets/projects/jetitnow/hero.jpeg';
import JetItNowThumbnail from '../assets/projects/jetitnow/thumb.jpeg';
import JetItNowIcon from '../assets/projects/jetitnow/icon.jpeg';
import JetItNowBanner from '../assets/projects/jetitnow/banner.jpeg';
import JetItNowScreenshot1 from '../assets/projects/jetitnow/screenshot1.webp';
import JetItNowScreenshot2 from '../assets/projects/jetitnow/screenshot2.webp';
import JetItNowScreenshot3 from '../assets/projects/jetitnow/screenshot3.webp';
import JetItNowScreenshot4 from '../assets/projects/jetitnow/screenshot4.webp';
import JetItNowScreenshot5 from '../assets/projects/jetitnow/screenshot5.webp';
import JetItNowScreenshot6 from '../assets/projects/jetitnow/screenshot6.webp';
import JetItNowScreenshot7 from '../assets/projects/jetitnow/screenshot7.webp';
import JetItNowScreenshot8 from '../assets/projects/jetitnow/screenshot8.webp';
import JetItNowScreenshot9 from '../assets/projects/jetitnow/screenshot9.webp';

import SketchesHero from '../assets/projects/sketches/hero.jpeg';
import SketchesThumbnail from '../assets/projects/sketches/thumb.jpeg';
import SketchesIcon from '../assets/projects/sketches/icon.jpeg';
import SketchesBanner from '../assets/projects/sketches/banner.jpeg';
import SketchesScreenshot1 from '../assets/projects/sketches/screenshot1.webp';
import SketchesScreenshot2 from '../assets/projects/sketches/screenshot2.webp';
import SketchesScreenshot3 from '../assets/projects/sketches/screenshot3.webp';
import SketchesScreenshot4 from '../assets/projects/sketches/screenshot4.webp';
import SketchesScreenshot5 from '../assets/projects/sketches/screenshot5.webp';
import SketchesScreenshot6 from '../assets/projects/sketches/screenshot6.webp';
import SketchesScreenshot7 from '../assets/projects/sketches/screenshot7.webp';
import SketchesScreenshot8 from '../assets/projects/sketches/screenshot8.webp';
import SketchesScreenshot9 from '../assets/projects/sketches/screenshot9.webp';

import BiodermaLiveQuizHero from '../assets/projects/biodermalivequiz/hero.jpeg';
import BiodermaLiveQuizThumbnail from '../assets/projects/biodermalivequiz/thumb.jpeg';
import BiodermaLiveQuizIcon from '../assets/projects/biodermalivequiz/icon.jpeg';
import BiodermaLiveQuizBanner from '../assets/projects/biodermalivequiz/banner.jpeg';
import BiodermaLiveQuizScreenshot1 from '../assets/projects/biodermalivequiz/screenshot1.jpeg';
import BiodermaLiveQuizScreenshot2 from '../assets/projects/biodermalivequiz/screenshot2.jpeg';
import BiodermaLiveQuizScreenshot3 from '../assets/projects/biodermalivequiz/screenshot3.jpeg';
import BiodermaLiveQuizScreenshot4 from '../assets/projects/biodermalivequiz/screenshot4.jpeg';
import BiodermaLiveQuizScreenshot5 from '../assets/projects/biodermalivequiz/screenshot5.jpeg';

import SillyMemoryHero from '../assets/projects/sillymemory/hero.jpeg';
import SillyMemoryThumbnail from '../assets/projects/sillymemory/thumb.jpeg';
import SillyMemoryIcon from '../assets/projects/sillymemory/icon.jpeg';
import SillyMemoryBanner from '../assets/projects/sillymemory/banner.jpeg';
import SillyMemoryScreenshot1 from '../assets/projects/sillymemory/screenshot1.webp';
import SillyMemoryScreenshot2 from '../assets/projects/sillymemory/screenshot2.webp';
import SillyMemoryScreenshot3 from '../assets/projects/sillymemory/screenshot3.webp';
import SillyMemoryScreenshot4 from '../assets/projects/sillymemory/screenshot4.webp';
import SillyMemoryScreenshot5 from '../assets/projects/sillymemory/screenshot5.webp';
import SillyMemoryScreenshot6 from '../assets/projects/sillymemory/screenshot6.webp';
import SillyMemoryScreenshot7 from '../assets/projects/sillymemory/screenshot7.webp';
import SillyMemoryScreenshot8 from '../assets/projects/sillymemory/screenshot8.webp';

import TheotokosHero from '../assets/projects/theotokos/hero.jpeg';
import TheotokosThumbnail from '../assets/projects/theotokos/thumb.jpeg';
import TheotokosIcon from '../assets/projects/theotokos/icon.jpeg';
import TheotokosBanner from '../assets/projects/theotokos/banner.jpeg';
import TheotokosScreenshot1 from '../assets/projects/theotokos/screenshot1.webp';
import TheotokosScreenshot2 from '../assets/projects/theotokos/screenshot2.webp';
import TheotokosScreenshot3 from '../assets/projects/theotokos/screenshot3.webp';
import TheotokosScreenshot4 from '../assets/projects/theotokos/screenshot4.webp';

import SkicaseHero from '../assets/projects/skicase/hero.jpeg';
import SkicaseThumbnail from '../assets/projects/skicase/thumb.jpeg';
import SkicaseIcon from '../assets/projects/skicase/icon.jpeg';
import SkicaseBanner from '../assets/projects/skicase/banner.jpeg';
import SkicaseScreenshot1 from '../assets/projects/skicase/screenshot1.jpeg';
import SkicaseScreenshot2 from '../assets/projects/skicase/screenshot2.jpeg';
import SkicaseScreenshot3 from '../assets/projects/skicase/screenshot3.jpeg';

import BiodermaCommerciauxHero from '../assets/projects/biodermacommerciaux/hero.jpeg';
import BiodermaCommerciauxThumbnail from '../assets/projects/biodermacommerciaux/thumb.jpeg';
import BiodermaCommerciauxIcon from '../assets/projects/biodermacommerciaux/icon.jpeg';
import BiodermaCommerciauxBanner from '../assets/projects/biodermacommerciaux/banner.jpeg';
import BiodermaCommerciauxScreenshot1 from '../assets/projects/biodermacommerciaux/screenshot1.jpeg';
import BiodermaCommerciauxScreenshot2 from '../assets/projects/biodermacommerciaux/screenshot2.jpeg';
import BiodermaCommerciauxScreenshot3 from '../assets/projects/biodermacommerciaux/screenshot3.jpeg';
import BiodermaCommerciauxScreenshot4 from '../assets/projects/biodermacommerciaux/screenshot4.jpeg';

import ImerysHero from '../assets/projects/imerys/hero.jpeg';
import ImerysThumbnail from '../assets/projects/imerys/thumb.jpeg';
import ImerysIcon from '../assets/projects/imerys/icon.jpeg';
import ImerysBanner from '../assets/projects/imerys/banner.jpeg';
import ImerysScreenshot1 from '../assets/projects/imerys/screenshot1.jpeg';
import ImerysScreenshot2 from '../assets/projects/imerys/screenshot2.jpeg';
import ImerysScreenshot3 from '../assets/projects/imerys/screenshot3.jpeg';
import ImerysScreenshot4 from '../assets/projects/imerys/screenshot4.jpeg';
import ImerysScreenshot5 from '../assets/projects/imerys/screenshot5.jpeg';
import ImerysScreenshot6 from '../assets/projects/imerys/screenshot6.jpeg';

import WatchLiveHero from '../assets/projects/watchlive/hero.jpeg';
import WatchLiveThumbnail from '../assets/projects/watchlive/thumb.jpeg';
import WatchLiveIcon from '../assets/projects/watchlive/icon.jpeg';
import WatchLiveBanner from '../assets/projects/watchlive/banner.jpeg';
import WatchLiveScreenshot1 from '../assets/projects/watchlive/screenshot1.webp';
import WatchLiveScreenshot2 from '../assets/projects/watchlive/screenshot2.webp';
import WatchLiveScreenshot3 from '../assets/projects/watchlive/screenshot3.webp';
import WatchLiveScreenshot4 from '../assets/projects/watchlive/screenshot4.webp';

import RichessesDuTerroirHero from '../assets/projects/richessesduterroir/hero.jpeg';
import RichessesDuTerroirThumbnail from '../assets/projects/richessesduterroir/thumb.jpeg';
import RichessesDuTerroirIcon from '../assets/projects/richessesduterroir/icon.jpeg';
import RichessesDuTerroirBanner from '../assets/projects/richessesduterroir/banner.jpeg';
import RichessesDuTerroirScreenshot1 from '../assets/projects/richessesduterroir/screenshot1.jpeg';
import RichessesDuTerroirScreenshot2 from '../assets/projects/richessesduterroir/screenshot2.jpeg';
import RichessesDuTerroirScreenshot3 from '../assets/projects/richessesduterroir/screenshot3.jpeg';
import RichessesDuTerroirScreenshot4 from '../assets/projects/richessesduterroir/screenshot4.jpeg';
import RichessesDuTerroirScreenshot5 from '../assets/projects/richessesduterroir/screenshot5.jpeg';

import SLVHero from '../assets/projects/slv/hero.jpeg';
import SLVThumbnail from '../assets/projects/slv/thumb.jpeg';
import SLVIcon from '../assets/projects/slv/icon.jpeg';
import SLVBanner from '../assets/projects/slv/banner.jpeg';
import SLVScreenshot1 from '../assets/projects/slv/screenshot1.webp';
import SLVScreenshot2 from '../assets/projects/slv/screenshot2.webp';
import SLVScreenshot3 from '../assets/projects/slv/screenshot3.webp';
import SLVScreenshot4 from '../assets/projects/slv/screenshot4.webp';

import WatchEssentialsHero from '../assets/projects/watchessentials/hero.jpeg';
import WatchEssentialsThumbnail from '../assets/projects/watchessentials/thumb.jpeg';
import WatchEssentialsIcon from '../assets/projects/watchessentials/icon.jpeg';
import WatchEssentialsBanner from '../assets/projects/watchessentials/banner.jpeg';
import WatchEssentialsScreenshot1 from '../assets/projects/watchessentials/screenshot1.webp';
import WatchEssentialsScreenshot2 from '../assets/projects/watchessentials/screenshot2.webp';
import WatchEssentialsScreenshot3 from '../assets/projects/watchessentials/screenshot3.webp';

import CDOEngineHero from '../assets/projects/cdoengine/hero.jpeg';
import CDOEngineThumbnail from '../assets/projects/cdoengine/thumb.jpeg';
import CDOEngineIcon from '../assets/projects/cdoengine/icon.jpeg';
import CDOEngineBanner from '../assets/projects/cdoengine/banner.jpeg';

import PuissanceNintendoHero from '../assets/projects/puissancenintendo/hero.jpeg';
import PuissanceNintendoThumbnail from '../assets/projects/puissancenintendo/thumb.jpeg';
import PuissanceNintendoIcon from '../assets/projects/puissancenintendo/icon.jpeg';
import PuissanceNintendoBanner from '../assets/projects/puissancenintendo/banner.jpeg';
import PuissanceNintendoScreenshot1 from '../assets/projects/puissancenintendo/screenshot1.webp';
import PuissanceNintendoScreenshot2 from '../assets/projects/puissancenintendo/screenshot2.webp';
import PuissanceNintendoScreenshot3 from '../assets/projects/puissancenintendo/screenshot3.webp';
import PuissanceNintendoScreenshot4 from '../assets/projects/puissancenintendo/screenshot4.webp';
import PuissanceNintendoScreenshot5 from '../assets/projects/puissancenintendo/screenshot5.webp';
import PuissanceNintendoScreenshot6 from '../assets/projects/puissancenintendo/screenshot6.webp';
import PuissanceNintendoScreenshot7 from '../assets/projects/puissancenintendo/screenshot7.webp';
import PuissanceNintendoScreenshot8 from '../assets/projects/puissancenintendo/screenshot8.webp';

import { defaultLocale, getLocaleFromPath } from '../i18n/locales';
import projectContentEn from './projects.en';
import projectContentFr from './projects.fr';

const projectContent = {
  en: projectContentEn,
  fr: projectContentFr,
};

const BaseDataSource = [
  {
    image: SweetHome3DHero,
    thumbnail: SweetHome3DThumbnail,
    icon: SweetHome3DIcon,
    banner: SweetHome3DBanner,
    screenshots: [SweetHome3DMac1, SweetHome3DMac2, SweetHome3DMobile4, SweetHome3DMobile3, SweetHome3DMobile2],
    preserveScreenshotAspectRatio: true,
    slug: "sweet-home-3d",
    tags: ["flutter", "ios", "android", "mobile-apps", "graphics"],
    techs: ["Flutter", "Dart", "OpenGL", "Metal", "DirectX"],
    website: "https://www.sweethome3d.com/"
  },
  {
    image: Arcade4FunHero,
    thumbnail: Arcade4FunThumbnail,
    icon: Arcade4FunIcon,
    banner: Arcade4FunBanner,
    screenshots: [
      Arcade4FunScreenshot1,
      Arcade4FunScreenshot2
    ],
    slug: "arcade-4-fun",
    tags: [
      "flutter",
      "android"
    ],
    techs: [
      "Flutter",
      "C",
      "Kotlin"
    ],
    website: "https://arcade4.fun"
  },
  {
    image: PocketHamsterManiaHero,
    thumbnail: PocketHamsterManiaThumbnail,
    icon: PocketHamsterManiaIcon,
    banner: PocketHamsterManiaBanner,
    screenshots: [
      PocketHamsterManiaScreenshot1,
      PocketHamsterManiaScreenshot2,
      PocketHamsterManiaScreenshot3,
      PocketHamsterManiaScreenshot4,
      PocketHamsterManiaScreenshot5,
      PocketHamsterManiaScreenshot6,
      PocketHamsterManiaScreenshot7,
      PocketHamsterManiaScreenshot8
    ],
    slug: "pocket-hamster-mania",
    tags: [
      "project-management",
      "unity",
      "ios",
      "android"
    ],
    techs: [
      "Unity",
      "C#",
      "Node.js",
      "MongoDB"
    ],
    website: "https://www.pockethamstermania.com/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/pocket-hamster-mania/id6470218141",
      googlePlay: "https://play.google.com/store/apps/details?id=com.cdoapps.idlehamsters"
    }
  },
  {
    image: YatamaHero,
    thumbnail: YatamaThumbnail,
    icon: YatamaIcon,
    banner: YatamaBanner,
    screenshots: [
      YatamaScreenshot1,
      YatamaScreenshot2,
      YatamaScreenshot3,
      YatamaScreenshot4,
      YatamaScreenshot5,
      YatamaScreenshot6,
      YatamaScreenshot7
    ],
    slug: "yatama",
    tags: [
      "graphics",
      "ios"
    ],
    techs: [
      "Swift",
      "Objective-C",
      "C",
      "OpenGL"
    ],
    website: "https://www.tayasui.com/yatama/",
    stores: {
      appStore: "https://apps.apple.com/us/app/tayasui-yatama/id6469051887"
    }
  },
  {
    image: FilbingBoxHero,
    thumbnail: FilbingBoxThumbnail,
    icon: FilbingBoxIcon,
    banner: FilbingBoxBanner,
    screenshots: [
      FilbingBoxScreenshot1,
      FilbingBoxScreenshot2,
      FilbingBoxScreenshot3,
      FilbingBoxScreenshot4,
      FilbingBoxScreenshot5
    ],
    slug: "filbing-box",
    tags: [
      "back-end",
      "flutter",
      "ios",
      "android"
    ],
    techs: [
      "Flutter",
      "Java",
      "C"
    ],
    website: "https://www.filbing-distribution.com/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/filbing-box-v4/id1624718168",
      googlePlay: "https://play.google.com/store/apps/details?id=com.filbing.boxremote"
    }
  },
  {
    image: TrackAndBurnHero,
    thumbnail: TrackAndBurnThumbnail,
    icon: TrackAndBurnIcon,
    banner: TrackAndBurnBanner,
    screenshots: [
      TrackAndBurnScreenshot1,
      TrackAndBurnScreenshot2,
      TrackAndBurnScreenshot3,
      TrackAndBurnScreenshot4,
      TrackAndBurnScreenshot5,
      TrackAndBurnScreenshot6
    ],
    slug: "track-and-burn",
    tags: [
      "unity",
      "ios"
    ],
    techs: [
      "Unity",
      "C#"
    ],
    stores: {
      appStore: "#",
      steam: "https://store.steampowered.com/app/1668170/Track_and_Burn/"
    }
  },
  {
    image: SSBEHero,
    thumbnail: SSBEThumbnail,
    icon: SSBEIcon,
    banner: SSBEBanner,
    screenshots: [
      SSBEScreenshot1,
      SSBEScreenshot2
    ],
    slug: "ssbe-re",
    tags: [
      "back-end"
    ],
    techs: [
      "Firebase",
      "JavaScript"
    ],
    website: "https://ssbe.re/"
  },
  {
    image: JetItNowHero,
    thumbnail: JetItNowThumbnail,
    icon: JetItNowIcon,
    banner: JetItNowBanner,
    screenshots: [
      JetItNowScreenshot1,
      JetItNowScreenshot2,
      JetItNowScreenshot3,
      JetItNowScreenshot4,
      JetItNowScreenshot5,
      JetItNowScreenshot6,
      JetItNowScreenshot7,
      JetItNowScreenshot8,
      JetItNowScreenshot9
    ],
    slug: "jetitnow",
    tags: [
      "mobile-apps",
      "project-management",
      "flutter",
      "ios",
      "android"
    ],
    techs: [
      "Flutter",
      "Firebase"
    ],
    website: "https://www.jetitnow.com/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/jetitnow/id1586848363?mt=8",
      googlePlay: "#"
    }
  },
  {
    image: SketchesHero,
    thumbnail: SketchesThumbnail,
    icon: SketchesIcon,
    banner: SketchesBanner,
    screenshots: [
      SketchesScreenshot1,
      SketchesScreenshot2,
      SketchesScreenshot3,
      SketchesScreenshot4,
      SketchesScreenshot5,
      SketchesScreenshot6,
      SketchesScreenshot7,
      SketchesScreenshot8,
      SketchesScreenshot9
    ],
    slug: "sketches",
    tags: [
      "mobile-apps",
      "ios"
    ],
    techs: [
      "Swift",
      "Objective-C",
      "C",
      "OpenGL"
    ],
    website: "https://www.tayasui.com/sketches/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/tayasui-sketches/id641900855"
    }
  },
  {
    image: BiodermaLiveQuizHero,
    thumbnail: BiodermaLiveQuizThumbnail,
    icon: BiodermaLiveQuizIcon,
    banner: BiodermaLiveQuizBanner,
    screenshots: [
      BiodermaLiveQuizScreenshot1,
      BiodermaLiveQuizScreenshot2,
      BiodermaLiveQuizScreenshot3,
      BiodermaLiveQuizScreenshot4,
      BiodermaLiveQuizScreenshot5
    ],
    slug: "be-bioderma-live-quiz",
    tags: [
      "ios",
      "android"
    ],
    techs: [
      "Swift",
      "Kotlin"
    ],
    website: "https://www.be.naos.fr/",
    stores: {
      appStore: "#",
      googlePlay: "#"
    }
  },
  {
    image: SillyMemoryHero,
    thumbnail: SillyMemoryThumbnail,
    icon: SillyMemoryIcon,
    banner: SillyMemoryBanner,
    screenshots: [
      SillyMemoryScreenshot1,
      SillyMemoryScreenshot2,
      SillyMemoryScreenshot3,
      SillyMemoryScreenshot4,
      SillyMemoryScreenshot5,
      SillyMemoryScreenshot6,
      SillyMemoryScreenshot7,
      SillyMemoryScreenshot8
    ],
    slug: "silly-memory",
    tags: [
      "ios",
      "android"
    ],
    techs: [
      "Objective-C",
      "Java",
      "C",
      "OpenGL"
    ],
    website: "https://www.sillymemory.com/",
    stores: {
      appStore: "#",
      googlePlay: "#"
    }
  },
  {
    image: TheotokosHero,
    thumbnail: TheotokosThumbnail,
    icon: TheotokosIcon,
    banner: TheotokosBanner,
    screenshots: [
      TheotokosScreenshot1,
      TheotokosScreenshot2,
      TheotokosScreenshot3,
      TheotokosScreenshot4
    ],
    slug: "theotokos",
    tags: [
      "ios",
      "android"
    ],
    techs: [
      "Objective-C",
      "Java"
    ],
    wesite: "https://www.theotokos.fr/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/theotokos-rencontre-chr%C3%A9tienne/id1525219542",
      googlePlay: "https://play.google.com/store/apps/details?id=com.eleousa.theotokosapp"
    }
  },
  {
    image: SkicaseHero,
    thumbnail: SkicaseThumbnail,
    icon: SkicaseIcon,
    banner: SkicaseBanner,
    screenshots: [
      SkicaseScreenshot1,
      SkicaseScreenshot2,
      SkicaseScreenshot3
    ],
    slug: "skicase",
    tags: [
      "ios",
      "android"
    ],
    techs: [
      "Objective-C",
      "Java"
    ],
    website: "https://myskicase.com/",
    stores: {
      appStore: "#",
      googlePlay: "#"
    }
  },
  {
    image: BiodermaCommerciauxHero,
    thumbnail: BiodermaCommerciauxThumbnail,
    icon: BiodermaCommerciauxIcon,
    banner: BiodermaCommerciauxBanner,
    screenshots: [
      BiodermaCommerciauxScreenshot1,
      BiodermaCommerciauxScreenshot2,
      BiodermaCommerciauxScreenshot3,
      BiodermaCommerciauxScreenshot4
    ],
    slug: "be-bioderma-commerciaux",
    tags: [
      "android"
    ],
    techs: [
      "Java"
    ]
  },
  {
    image: ImerysHero,
    thumbnail: ImerysThumbnail,
    icon: ImerysIcon,
    banner: ImerysBanner,
    screenshots: [
      ImerysScreenshot1,
      ImerysScreenshot2,
      ImerysScreenshot3,
      ImerysScreenshot4,
      ImerysScreenshot5,
      ImerysScreenshot6
    ],
    slug: "imerys",
    tags: [
      "ios"
    ],
    techs: [
      "Objective-C"
    ]
  },
  {
    image: WatchLiveHero,
    thumbnail: WatchLiveThumbnail,
    icon: WatchLiveIcon,
    banner: WatchLiveBanner,
    screenshots: [
      WatchLiveScreenshot1,
      WatchLiveScreenshot2,
      WatchLiveScreenshot3,
      WatchLiveScreenshot4
    ],
    slug: "fhh-watch-live",
    tags: [
      "ios"
    ],
    techs: [
      "Objective-C"
    ],
    website: "https://watchlive.hautehorlogerie.org/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/watch-live-fhh-academy/id1265921664"
    }
  },
  {
    image: RichessesDuTerroirHero,
    thumbnail: RichessesDuTerroirThumbnail,
    icon: RichessesDuTerroirIcon,
    banner: RichessesDuTerroirBanner,
    screenshots: [
      RichessesDuTerroirScreenshot1,
      RichessesDuTerroirScreenshot2,
      RichessesDuTerroirScreenshot3,
      RichessesDuTerroirScreenshot4,
      RichessesDuTerroirScreenshot5
    ],
    slug: "richesses-du-terroir",
    tags: [
      "ios"
    ],
    techs: [
      "Objective-C"
    ]
  },
  {
    image: SLVHero,
    thumbnail: SLVThumbnail,
    icon: SLVIcon,
    banner: SLVBanner,
    screenshots: [
      SLVScreenshot1,
      SLVScreenshot2,
      SLVScreenshot3,
      SLVScreenshot4
    ],
    slug: "slv",
    tags: [
      "ios",
      "android"
    ],
    techs: [
      "Objective-C",
      "Java"
    ],
    website: "https://www.slv.com/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/slv-france/id1176289130",
      googlePlay: "https://play.google.com/store/apps/details?id=com.slv.pocket"
    }
  },
  {
    image: WatchEssentialsHero,
    thumbnail: WatchEssentialsThumbnail,
    icon: WatchEssentialsIcon,
    banner: WatchEssentialsBanner,
    screenshots: [
      WatchEssentialsScreenshot1,
      WatchEssentialsScreenshot2,
      WatchEssentialsScreenshot3
    ],
    slug: "fhh-watch-essentials",
    tags: [
      "ios",
      "android"
    ],
    techs: [
      "Objective-C",
      "Java"
    ],
    website: "https://www.hautehorlogerie.org/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/watch-essentials/id1141456162",
      googlePlay: "https://play.google.com/store/apps/details?id=com.fhh.watchessentials"
    }
  },
  {
    image: CDOEngineHero,
    thumbnail: CDOEngineThumbnail,
    icon: CDOEngineIcon,
    banner: CDOEngineBanner,
    slug: "cdo-engine",
    tags: [
      "graphics"
    ],
    techs: [
      "Objective-C",
      "C",
      "OpenGL"
    ]
  },
  {
    image: PuissanceNintendoHero,
    thumbnail: PuissanceNintendoThumbnail,
    icon: PuissanceNintendoIcon,
    banner: PuissanceNintendoBanner,
    screenshots: [
      PuissanceNintendoScreenshot1,
      PuissanceNintendoScreenshot2,
      PuissanceNintendoScreenshot3,
      PuissanceNintendoScreenshot4,
      PuissanceNintendoScreenshot5,
      PuissanceNintendoScreenshot6,
      PuissanceNintendoScreenshot7,
      PuissanceNintendoScreenshot8
    ],
    slug: "puissance-nintendo",
    tags: [
      "ios"
    ],
    techs: [
      "Objective-C"
    ],
    website: "https://www.p-nintendo.com/",
    stores: {
      appStore: "https://apps.apple.com/fr/app/puissance-nintendo-lactu-switch-3ds-et-wii-u/id979005544"
    }
  }
];

function currentLocale() {
  return typeof window === 'undefined' ? defaultLocale : getLocaleFromPath(window.location.pathname);
}

function contentForProject(project, locale) {
  return {
    ...projectContent.fr[project.slug],
    ...projectContent[locale]?.[project.slug],
  };
}

function localizedDataSource(locale) {
  return BaseDataSource.map(project => ({
    ...project,
    ...contentForProject(project, locale),
  }));
}

function Query({filter, key, sort, ascending, limit, offset, locale} = {}) {
  locale = locale || currentLocale();
  let data = localizedDataSource(locale);

  if (filter) {
    key = key || "tags";
    data = data.filter(project => {
      const values = project[key];
      if (typeof values === "string") {
        return values === filter;
      } else if (Array.isArray(values)) {
        return values.includes(filter);
      } else {
        return false;
      }
    });
  }

  if (sort) {
    ascending = ascending || true;
    data = data.sort((a, b) => {
      const valueA = a[sort];
      const valueB = b[sort];
      if (typeof valueA === "string") {
        return ascending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      } else {
        return 0;
      }
    });
  }

  if (limit) {
    const length = data.length;
    offset = offset || 0;
    if (offset >= length) {
      return [];
    }

    limit = Math.min(length - offset, limit);
    data = data.slice(offset, offset + limit);
  }

  return data;
}

export default Query;
